/**
 * Site-Database Codegen wire schemas (shared).
 *
 * The on-the-wire shape of a workspace's database definitions as consumed by
 * the codegen service (`@repo/services/site-database-codegen`). Shared so both
 * RPC surfaces describe the *same* shape without drifting:
 *
 *   - `PreTaskOpsRpc.getSiteDatabasesForCodegen` — VTM-facing (workspaceId payload)
 *   - `SessionRpc.getSessionSiteDatabases`      — CLI-facing (workspaceId from session)
 *
 * Kept middleware-free and RPC-free on purpose: the CLI bundles `SessionRpc`
 * alone, so importing these schemas must not drag in any other API surface.
 *
 * @module
 */
import { Schema as S } from "effect"

export const CodegenFieldDefSchema = S.Struct({
  type: S.String,
  required: S.Boolean,
  options: S.optional(S.Array(S.String)),
})
export type CodegenFieldDef = typeof CodegenFieldDefSchema.Type

export const CodegenDatabaseSchema = S.Struct({
  name: S.String,
  description: S.String,
  accessMode: S.String,
  schema: S.Struct({
    fields: S.Record(S.String, CodegenFieldDefSchema),
  }),
  schemaVersion: S.Number,
})
export type CodegenDatabase = typeof CodegenDatabaseSchema.Type
